import React from 'react';

import { Container, Explain } from './styles';
import CloseMatchExplanation from 'components/property-close-match/close-match-explanation';

const PropertyCloseMatch = () => {
  const [explanationOpen, setExplanationOpen] = React.useState(false);
  return (
    <>
      <Container
        onClick={(e) => {
          setExplanationOpen(true);
          e.preventDefault();
        }}
      >
        Close Match{' '}
        <Explain
          onClick={(e) => {
            setExplanationOpen(true);
            e.preventDefault();
          }}
        >
          ?
        </Explain>
      </Container>
      {explanationOpen && (
        <CloseMatchExplanation
          onClose={() => {
            setExplanationOpen(false);
          }}
        />
      )}
    </>
  );
};

export default PropertyCloseMatch;
